import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Owner} from "../../../model/customer/owner";
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import TYPE = FormFieldConfig.TYPE;
import {ClearingHouse} from "../../../model/exchange/clearing-house";
import {ExchangeClearingHouseService} from "../../../services/exchange/exchange-clearing-house.service";
import {AccountType} from "../../../model/exchange/account-type";
import {ExchangeAccountTypeService} from "../../../services/exchange/exchange-account-type.service";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {TradingEnvironment} from "../../../model/exchange/trading-environment";
import {ExchangeTradingEnvironmentService} from "../../../services/exchange/exchange-trading-environmentservice";

@Component({
  selector: 'app-trading-env',
  templateUrl: './trading-environment.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class TradingEnvironmentComponent extends CrudBaseComponent<TradingEnvironment> {

  //fields
  clearingHouses: FieldRecord<any>[]
  exchanges: FieldRecord<any>[]
  displayedExchangeCodes: FieldRecord<any>[]

  constructor(cdref: ChangeDetectorRef,
              tradingEnvironmentService: ExchangeTradingEnvironmentService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = tradingEnvironmentService;
    this.newRecord = new TradingEnvironment();
    this.newRecord.exchangeCode = ExchangeDetail.ALL;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.code = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'clearingHouse',
        width: 130
      },
      {
        field: 'exchangeCode',
        width: 150,
        mapId: record => !record.exchangeCode || record.exchangeCode === ExchangeDetail.ALL ? ExchangeDetail.ALL_TEXT : record.exchangeCode,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.exchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'code',
        width: 150,
      },
      {
        field: 'description',
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'clearingHouse',
            required: true,
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.clearingHouses,
            changed: event => this.filterExchanges()
          },
          {
            field: 'exchangeCode',
            filter: true,
            column: 6,
            type: TYPE.DROPDOWN,
            options: () => this.displayedExchangeCodes,
            icon: (ig: any) => {
              const exchField = this.displayedExchangeCodes.find(field => field.value && field.value.code === ig);
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            },
            optionValue: 'id'
          },
          {
            field: 'code',
            required: true,
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'description',
            column: 9,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getClearingHouses(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.clearingHouses = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.filterExchanges();
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

  }

  private filterExchanges() {
    let defaultAllExchange = FieldRecord.DEFAULT();
    defaultAllExchange.text = this.translateService.instant('page.account.form.defaultExchangeAll');
    defaultAllExchange.id = ExchangeDetail.ALL;
    if (this.exchanges && this.formRecord) {
      this.displayedExchangeCodes = this.exchanges.filter(field => this.formRecord.clearingHouse && field.value && this.formRecord.clearingHouse === field.value.clearingHouse);
      this.displayedExchangeCodes.unshift(defaultAllExchange);
      if (this.displayedExchangeCodes.filter(value => value.id === this.formRecord.exchangeCode).length == 0)
        this.formRecord.exchangeCode = ExchangeDetail.ALL;
    } else {
      this.displayedExchangeCodes = [defaultAllExchange];
    }
  }

  onFormShow() {
    this.filterExchanges();
  }
}
